
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import { login, Loginp } from "@/api/Login";
type loginType = "phone" | "password" | "register";
@Component
export default class Login extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: "phone" }) active!: loginType;
  private form!: Loginp = { userIdentity: "" };
  @Emit("update:visible")
  changeVisible() {
    return !this.visible;
  }

  private time = 0;
  private timer!: number;

  @Watch("time")
  change(time: number) {
    if (time === 1) {
      this.timer = setInterval(() => {
        this.time = this.time + 1;
      }, 1000);
      this.$on("hook:destroy", () => {
        clearInterval(this.timer);
      });
    } else if (time === 60) {
      clearInterval(this.timer);
      this.time = 0;
    }
  }

  goLogin() {
    console.log(this.form);
  }
  mounted() {
    console.log(this.$route);
  }
  render() {
    return (
      <div>
        <a-modal
          width="450px"
          footer={null}
          visible={this.visible}
          on={{
            cancel: () => {
              this.changeVisible();
            }
          }}
        >
          <div class="title">
            {this.active !== "register" ? "登录" : "注册"}
          </div>
          {this.active !== "register" && (
            <div class="zc-tip">
              没有账号？去
              <span
                class="zc"
                onClick={() => {
                  this.active = "register";
                }}
              >
                注册
              </span>
            </div>
          )}
          <div style="height:20px;"></div>
          <a-form form={this.form}>
            {/**手机号登录 */}
            {this.active === "phone" && (
              <div>
                <a-form-item>
                  <a-input
                    placeholder="请输入手机号"
                    size="large"
                    on={{
                      "bind:decorator": [
                        "userIdentity",
                        {
                          rules: [
                            {
                              required: true,
                              message: "Please input your note!"
                            }
                          ]
                        }
                      ]
                    }}
                  />
                </a-form-item>
                <a-form-item>
                  <div style="display:flex;">
                    <a-input
                      placeholder="请输入验证码"
                      size="large"
                      on={{
                        "bind:decorator": [
                          "smsCode",
                          {
                            rules: [
                              {
                                required: true,
                                message: "Please input your note!"
                              }
                            ]
                          }
                        ]
                      }}
                    ></a-input>
                    <div style="height:100%;width:10px;"></div>
                    {this.time > 0 ? (
                      <a-button size="large" class="ty-btn-ghost" ghost>
                        倒计时{this.time}s
                      </a-button>
                    ) : (
                      <a-button
                        size="large"
                        class="ty-btn"
                        onClick={() => {
                          this.time = 1;
                        }}
                      >
                        获取验证码
                      </a-button>
                    )}
                  </div>
                </a-form-item>
              </div>
            )}
            {/**账号密码登录 */}

            {(this.active === "password" || this.active === "register") && (
              <div>
                <a-form-item>
                  <a-input
                    placeholder="请输入用户名"
                    size="large"
                    v-decorator="['userIdentity', { rules: [{ required: true, message: 'Please input your note!' }] }]"
                  />
                </a-form-item>
                <a-form-item>
                  <a-input
                    placeholder="请输入密码"
                    size="large"
                    v-decorator="['password', { rules: [{ required: true, message: 'Please input your note!' }] }]"
                  ></a-input>
                  <div style="height:100%;width:10px;"></div>
                </a-form-item>
              </div>
            )}
            <div class="agreement">
              登陆即代表同意<span>《用户协议》</span>及<span>《隐私协议》</span>
            </div>
            <a-form-item>
              {this.active === "register" ? (
                <a-button
                  size="large"
                  class="ty-btn"
                  type="primary"
                  html-type="submit"
                  block
                >
                  注册
                </a-button>
              ) : (
                <a-button
                  size="large"
                  class="ty-btn"
                  type="primary"
                  html-type="submit"
                  block
                  onClick={this.goLogin}
                >
                  登录
                </a-button>
              )}

              <div class="login-type">
                {this.active === "phone" && (
                  <span
                    class="login-t"
                    onClick={() => {
                      this.active = "password";
                    }}
                  >
                    切换到账号密码登录
                  </span>
                )}
                {this.active === "password" && (
                  <span
                    class="login-t"
                    onClick={() => {
                      this.active = "phone";
                    }}
                  >
                    切换到手机号登录
                  </span>
                )}
                {this.active === "register" && (
                  <span
                    class="login-t"
                    onClick={() => {
                      this.active = "phone";
                    }}
                  >
                    去登陆
                  </span>
                )}
                <span>忘记密码</span>
              </div>
            </a-form-item>
          </a-form>
        </a-modal>
      </div>
    );
  }
}
